import { getUtcStringWithoutHours } from "./../../../utilities/helpers";

let commonLabels;
if (sessionStorage.getItem("lng") === "fr") {
  // eslint-disable-next-line global-require
  commonLabels = require("./../../../labels/labels.french.json").commonLabels;
} else {
  // eslint-disable-next-line global-require
  commonLabels = require("./../../../labels/labels.json").commonLabels;
}
const oneMinute = 60 * 1000;
const oneDay = 24 * 60 * 60 * 1000;

export function daysDiff(start, end) {
  const diff = (start - end) / oneDay;
  return Math.floor(Math.abs(diff));
}

export { getUtcStringWithoutHours };

export function getDatesRange(startDate, endDate) {
  const datesSteps = [];
  let date = startDate.valueOf();
  const lastDate = new Date(getUtcStringWithoutHours(endDate)).getTime();
  datesSteps.push(getUtcStringWithoutHours(date));
  while (date < lastDate) {
    datesSteps.push(getUtcStringWithoutHours((date += oneDay)));
  }
  return datesSteps;
}

export function getInputRangeLabels(datesRange) {
  return datesRange.map((i) => {
    const date = new Date(i);
    const day = date.getUTCDate();
    const month = commonLabels.dates.months[date.getUTCMonth()].substr(0, 3);
    return `${month} ${day}`;
  });
}

export function getInputRangeInit(vacationStart, vacationEnd, datesRange) {
  const min = datesRange.indexOf(vacationStart);
  const max = datesRange.indexOf(vacationEnd);
  return { min, max };
}

export function dateToIso(date, returnDayBefore = false) {
  if (!date) return "--";
  let dateTs = new Date(date).getTime();
  if (returnDayBefore) {
    dateTs -= oneMinute;
  }
  return new Date(dateTs).toISOString().substring(0, 10);
}
